import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTimecardTotalsQuickInfo extends Layout {
    labelHoliday: Label;
    labelHours: Label;
    labelLeaveBalances: Label;
    labelOvertime: Label;
    labelPayRate: Label;
    labelRegular: Label;
    labelSick: Label;
    labelTotal: Label;
    labelVacation: Label;
    panelHoliday: Panel;
    panelLeaveBalances: Panel;
    panelLeftHeaders: Panel;
    panelOvertime: Panel;
    panelRegular: Panel;
    panelSick: Panel;
    panelVacation: Panel;
    sourceOfficeTimecard: DataSource;
    textboxAddlTaxOverrideHours: Textbox;
    textboxHolidayTotal: Textbox;
    textboxHolidayUnits: Textbox;
    textboxId: Textbox;
    textboxOvertimeRate: Textbox;
    textboxOvertimeTotal: Textbox;
    textboxOvertimeUnits: Textbox;
    textboxPaymentFrequency: Textbox;
    textboxRegularRate: Textbox;
    textboxRegularRateHoliday: Textbox;
    textboxRegularRateSick: Textbox;
    textboxRegularTotal: Textbox;
    textboxRegularUnits: Textbox;
    textboxSick: Textbox;
    textboxSickTotal: Textbox;
    textboxSickUnits: Textbox;
    textboxVacation: Textbox;
    textboxVacationRate: Textbox;
    textboxVacationTotal: Textbox;
    textboxVacationUnits: Textbox;
}
